
//dynamically doing blocks sounds like a pain in the ass it would be easier to just create blocks via clicking
//and then parse that out simply easier for everyone involved


function floorplanIndexViaID(floorplans, ID) {
    var index = -1;

    for (var i = 0; i < floorplans.length; i++) {
        if (floorplans[i].ID == ID) index = i;
    }

    return index;
}

function lotIndexFromLotID(lotID, lots) {

    for (var i = 0; i < lots.length; i++) {
        if (lotID == lots[i].ID) return i;
    }

    return null;
}

function lotSideBySideAssociations(lot, lots, associations) {
    var assoc = [];
    var lotIndex = lotIndexFromLotID(lot.ID, lots);


    for (var i = 0; i < associations.length; i++) {
        if (associations[i].association_type == "1") {
            //the we need to see if any of the lots are the one we need
            if (associations[i].lot_one_id == lotIndex || associations[i].lot_two_id == lotIndex) {
                var otherIndex = -1;

                if (associations[i].lot_one_id == lotIndex) {
                    //now we need to get this next lot save it and then also get the one thats beside it that's not us
                    otherIndex = associations[i].lot_two_id;
                }
                else if (associations[i].lot_two_id == lotIndex) {
                    otherIndex = associations[i].lot_one_id;
                }

                //now we need to do the whole thing again with the other one to get the next layer
                assoc.push(otherIndex);

                //get the other one from the associations that's not the one we are
                for (var j = 0; j < associations.length; j++) {

                    if (associations[j].association_type == "1") {
                        if (
                            associations[j].lot_one_id == otherIndex || associations[j].lot_two_id == otherIndex &&
                            associations[j].lot_one_id != lotIndex && associations[j].lot_two_id != lotIndex
                        ) {
                            var secondIndex = -1;

                            //this is the one we need
                            //this should only et one
                            if (associations[j].lot_one_id == otherIndex && associations[j].lot_one_id != lotIndex) {
                                secondIndex = associations[j].lot_two_id;
                                //assoc.push(associations[j].lot_two_id);
                            }
                            if (associations[j].lot_two_id == otherIndex && associations[j].lot_one_id != lotIndex) {
                                //assoc.push(associations[j].lot_one_id);
                                secondIndex = associations[j].lot_one_id;
                            }

                            if(!assoc.includes(secondIndex))
                            assoc.push(secondIndex);
                        }
                    }
                }
            }
        }
    }

    return assoc;
}

function findGroupOf3Lots(lot, lots, associations) {
    //there's been an oversight and i need to create chains of 3 blocks side by side in either direction from the lot,
    //and then use those two chains to determine if we have a block of 3 and should fail or not
    //im dumb for not realizing this earlier.

    var side1 = [];
    var side2 = [];
    var lotIndex = lotIndexFromLotID(lot.ID, lots);

    for(var i = 0; i < associations.length; i++) {
        if(associations[i].association_type == "1") {
            if(
                associations[i].lot_one_id == lotIndex ||
                associations[i].lot_two_id == lotIndex
            ) {

                if (associations[i].lot_one_id == lotIndex) {
                    if(side1.length == 0) {
                        side1.push(associations[i].lot_two_id);
                    }
                    else {
                        side2.push(associations[i].lot_two_id);
                    }
                }
                else if(associations[i].lot_two_id == lotIndex) {
                    
                    if(side1.length == 0) {
                        side1.push(associations[i].lot_one_id);
                    }
                    else {
                        side2.push(associations[i].lot_one_id);
                    }
                }
            }
        }
    }

    //now do side one
    var activeIndex = -1;
    var previousIndex = -1;

    if(side1.length > 0) {
        previousIndex = -1;
        activeIndex = side1[0];

        while(activeIndex != -1 && side1.length < 3) {
            //nextIndex = -1;
            //we need to find the two associations here
            var foundSomething = false;
            for(var i = 0; i < associations.length; i++) {
                if(associations[i].association_type == "1") {
                    if(
                        (
                            associations[i].lot_one_id == activeIndex ||
                            associations[i].lot_two_id == activeIndex 
                        )
                        &&
                        (
                            !side1.includes(associations[i].lot_one_id) ||
                            !side1.includes(associations[i].lot_two_id)
                        )
                        &&
                        (
                            associations[i].lot_one_id != lotIndex &&
                            associations[i].lot_two_id != lotIndex
                        )
                    )  {
                        if(associations[i].lot_one_id == activeIndex) {
                            //aadd the other one
                            //if(lotIndex != associations[i].lot_two_id) {
                                side1.push(associations[i].lot_two_id);
                                previousIndex = associations[i].lot_two_id;
                                foundSomething = true;
                            //}
                        }
                        else if(associations[i].lot_two_id == activeIndex) {
                            //if(lotIndex != associations[i].lot_one_id) {
                                side1.push(associations[i].lot_one_id);
                                previousIndex = associations[i].lot_one_id;
                                foundSomething = true;
                            //}
                        }
                    }
                }
            }

            if(!foundSomething) {
                previousIndex = -1;
            }
            activeIndex = previousIndex;
        }
    }

    var activeIndex = -1;
    var previousIndex = -1;

    if(side2.length > 0) {
        previousIndex = -1;
        activeIndex = side2[0];

        while(activeIndex != -1 && side2.length < 3) {
            //nextIndex = -1;
            //we need to find the two associations here
            var foundSomething = false;
            for(var i = 0; i < associations.length; i++) {
                if(associations[i].association_type == "1") {
                    if(
                        (
                            associations[i].lot_one_id == activeIndex ||
                            associations[i].lot_two_id == activeIndex 
                        )
                        &&
                        (
                            !side2.includes(associations[i].lot_one_id) ||
                            !side2.includes(associations[i].lot_two_id)
                        )
                        &&
                        (
                            associations[i].lot_one_id != lotIndex &&
                            associations[i].lot_two_id != lotIndex
                        )
                    )  {
                        if(associations[i].lot_one_id == activeIndex) {
                            //aadd the other one
                            //if(lotIndex != associations[i].lot_two_id) {
                                side2.push(associations[i].lot_two_id);
                                previousIndex = associations[i].lot_two_id;
                                foundSomething = true;
                            //}
                        }
                        else if(associations[i].lot_two_id == activeIndex) {
                            //if(lotIndex != associations[i].lot_one_id) {
                                side2.push(associations[i].lot_one_id);
                                previousIndex = associations[i].lot_one_id;
                                foundSomething = true;
                            //}
                        }
                    }
                }
            }
            if(!foundSomething) {
                previousIndex = -1;
            }
            activeIndex = previousIndex;
        }
    }

    //console.log(side1);
    //console.log(side2);

    return {
        side1,
        side2
    }
}

function blockElevationValidityCheck(lot, lotIndex, blockIndex, blocks, lots, associations, floorplan, elevationIndex) {
    //two checks need to happeen in this function. The first is that we need to make sure that the blocks which are
    //within two spaces of this unit do not contain the same elevation
    var valid = true;

    //the second check is taht we need to ensure that no more then 30% of the total number of lots will be filled by a single
    //floorplan type should this elevation and floorplan be placed onto the block

    //so lets identify the lots that are within two of this unit first.
    //i need to know the index of the lot in the block then i need to find the index of the lots that are on the next spaces from me.
    //i think i should see how the data works to figure out how to do that
    //now that i know 

    //so like lets get the indexs of the lots in both directions we can get the lot to find the first two and then we can use that one to find the
    //next ones from there

    //kind of easy idea lets gooo  
    var otherLots = lotSideBySideAssociations(lot, lots, associations);
    var sidebysides = [];
    var threes = findGroupOf3Lots(lot, lots, associations);

    var floorplansCount = 0;
    //console.log(otherLots);
    //now we can check if any of these lots have the current floorplan and elevation selectged if they do then we cannot use it
    for (var i = 0; i < otherLots.length; i++) {
        var otherLot = lots[otherLots[i]];
        if (otherLot.ID !== lot.ID) {
            //i think i needed a more strict type check because javascript
            if (otherLot.floorplan != null && otherLot.floorplan != "" && otherLot.elevation != null && otherLot.elevation != "") {
                if (otherLot.floorplan == floorplan.ID && otherLot.elevation == elevationIndex) {
                    //the we can't use this one
                    valid = false;
                }
            }
            /*
            moving the floorplan type count to a new array c hecking in both directions to make sure we can't do it
            if (otherLot.floorplan == floorplan.ID) {
                floorplansCount++;
            }
            */
        }
    }

    if (lot.floorplan != floorplan.ID) {
        var keys = Object.keys(threes);
        for(var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var side = threes[key];
            var fpCount = 0;
    
            for(var j = 0; j < side.length; j++) {
                //run the same check as above
                var otherLot = lots[side[j]];
                if(otherLot.floorplan == floorplan.ID) {
                    fpCount++;
                }
            }
    
            if(fpCount >= 3) {
                valid = false;
            }
        }
    }
    

    //we need a plus one because we want to know if more then the current amount will be bigger then 3
    /*
    if (lot.floorplan != floorplan.ID)
        //uhhh actually on the front end i don't think we even really need extra 
        //if(floorplansCount+1 >= 3)
        if (floorplansCount + 1 > 3)
            valid = false;
    */
    /*
    if(!valid) {
        console.log('it failed afteer the floorplans count');
    } else console.log('still good over the floorplan count');
    */

    var block = blocks[blockIndex];
    //the last block check is if a single floorplan would be over 30% of the total of the block this number should be rounded down
    //so we just loop the block and see if the the floorplan and elevation show up more then 30% of the floorplan rounded down
    var thirtyPercent = Math.floor(block.lots.length * 0.3);
    if (thirtyPercent < 1) thirtyPercent = 1;

    //now we just check the blocks and make sure we're not going to break 30%

    var fpElvCount = 0;

    for (var i = 0; i < block.lots.length; i++) {
        var lt = lots[block.lots[i]];

        if (lt.floorplan == floorplan.ID && lt.elevation == elevationIndex) {
            fpElvCount++;
        }
    }

    if (fpElvCount != 0)
        //console.log(fpElvCount + 1);

    if (lot.floorplan != floorplan.ID)
        if (fpElvCount + 1 > thirtyPercent)
            valid = false;

    //console.log(valid);
    return valid;
}

//across the street check
function floorplanElevationValidityCheck(lot, associations, floorplan, elevationIndex, blocks, lots, lotAssociations) {
    //check the floorplan the lot has against teh associations
    //console.log(`the selected floorplan is: ${floorplan.post_title} : ${floorplan.elevation[elevationIndex].elevation_name}`);
    var valid = true;

    if (lot.floorplan == floorplan.ID) {
        //console.log(`{${lot.elevation} : ${elevationIndex}}`);
        //console.log('same as the lot floorplan');
    }
    for (var i = 0; i < associations.length; i++) {
        //make sure the assocation lots do not have our floorplan selected
        //make sure we can't have the same floorplan side by side
        //if(associations[i].association_type == 0 || associations[i].association_type == 1) {
        //if (associations[i].floorplan == floorplan.ID) console.log(floorplan.post_title);
        if (associations[i].floorplan == floorplan.ID && associations[i].elevation == elevationIndex) {
            valid = false;
        }
        //}
    }

    //check the block
    //find the block that has this floorplan in it
    var blockIndex = -1;
    var lotIndex = -1;

    for (var i = 0; i < blocks.length; i++) {
        //check to see if the current lot index is inside of the block to see if this is the one we are in 
        var blk = blocks[i];

        for (var j = 0; j < blk.lots.length; j++) {
            var lt = lots[blk.lots[j]];

            if (lt.ID == lot.ID) {
                //we're in this block
                blockIndex = i;
                lotIndex = j;
            }
        }
    }

    if (valid)
        //console.log('valid check passed');

        //so that loop was just to get the block lets figure out what to do now with the block
        //now we can run a function with the block against the lots that are in there ( which are in the block )
        //to see if the floorplan is still valid
        if (valid)
            valid = blockElevationValidityCheck(lot, lotIndex, blockIndex, blocks, lots, lotAssociations, floorplan, elevationIndex);

    //if(valid)
    //console.log('block check passed');
    // else console.log('block check failed');


    return valid;
}

export default {
    floorplanElevationValidityCheck,
};